export class OgcParams {
  bbox: string | null;
  srsName: string;
  offset: number;
  limit: number;
  
  // Optional parameters for search functionality
  filter?: string
  properties?: string;
  searchText?: string;
  skipGeometry?: boolean;

  constructor() {
    this.bbox = null; // Initialize as null
    this.srsName = 'EPSG:28992'; // Default value
    this.offset = 0; // Default offset
    this.limit = 100; // Default limit

    this.filter = undefined; // No filter by default
    this.properties = undefined; // No specific properties by default
    this.searchText = undefined; // Default search text
    this.skipGeometry = false; // Default to not skip geometry
  }
}
